<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>General Authorization</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mb-2">
          <v-col cols="12" md="4">
            <v-autocomplete
              autocomplete="off"
              name="userGroup"
              hide-details
              dense
              outlined
              v-model="userGroup"
              :items="userGroups"
              label="Select User Group"
              item-text="name"
              item-value="id"
              @change="getAssignedUserMenus"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense v-show="userGroup">
          <v-col cols="12">
            <v-treeview
              v-model="userMenus"
              selectable
              selection-type="independent"
              color="primary"
              :activatable="true"
              :hoverable="true"
              item-text="text"
              item-children="children"
              :items="allMenus"
              :search="search"
              :open-all="true"
            >
              <template v-slot:label="{ item }">
                <div @click="selectItem(item)">
                  <span style="font-weight: bold">{{item.text}}</span>
                </div>
              </template>
            </v-treeview>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row>
          <v-col cols="12">
            <v-btn
              class="mt-4 float-right"
              color="primary"
              small
              :loading="loader"
              @click="updateMenu"
            >
              <v-icon left>mdi-content-save</v-icon>Update Side Menu
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar> 
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: null,
    itemsPerPage: 100,
    dialog: false,
    searchUser: null,
    groupModal: false,
    loading: false,
    loader: false,
    trueValue: true,
    userName: null,
    userGroup: null,
    userGroups: [],
    userMenus: [],
    allMenus: [],
    authData: [],
    groupAuthData: [],
    activeStatus: false,
    activeUser: null,
    activeGroup: {},
    activeItem: {},
    groupRights: [],
    authorizations: [
      { name: "Full Authorization" },
      { name: "Readonly" },
      { name: "No Authorization" }
    ],
    userHeaders: [
      { text: "Name", value: "name" }
      // { text: "Action", value: "action" },
    ],
    headers: [
      { text: "Subject", value: "DocumentName" },
      { text: "Read", value: "read" },
      { text: "Write", value: "write" },
      { text: "Update", value: "update" },
      { text: "Action", value: "groups" }
    ],
    groupHeaders: [
      { text: "Group", value: "name" },
      { text: "Read", value: "read" },
      { text: "Write", value: "write" },
      { text: "Update", value: "update" }
    ],
    userGroupHeaders: [{ text: "Group", value: "name" }]
  }),
  computed: {
    userId() {
      return localStorage.getItem("user_id");
    }
  },
  methods: {
    selectItem(data) {
      this.activeItem = data;
      this.dialog = true;
    },
    updateMenu() {
      if (!this.userGroup) {
        this.$refs.snackbar.show("Please select a user group", "red");
        return;
      }

      var adminGroupId = this.userGroups[0].id;

      if (this.userGroup == adminGroupId) {
        this.$refs.snackbar.show("You are not allowed to update this group, please manage a new one !", "red");
        return;
      }

      var data = {
        groupId: this.userGroup,
        menus: this.userMenus
      };

      const url = `/assign-roles-to-group`;

      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGroups() {
      const url = "/user-groups";
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.loader = false;
          self.userGroups = res.ResponseData;
          // self.userGroups.shift();
        })
        .catch(() => {});
    },
    getGeneralMenu() {
      const url = `/general-menu`;
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.allMenus = res.ResponseData;
          self.$store.commit("loader", false);
        })
        .catch(() => {});
    },
    getAssignedUserMenus() {
      const groupId = this.userGroup;
      const url = `/menu-setup-user-assigned/${groupId}`;
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {
          self.userMenus = res.ResponseData;
          self.$store.commit("loader", false);
        })
        .catch(() => {});
    }
  },
  created() {
  Promise.all([this.getGeneralMenu(), this.getGroups()])
  }
};
</script>